module.exports = __webpack_public_path__ + "static/media/logo_afferolab_dark_bg.883a1877.svg";